import React from 'react';
import { coursesData } from '../data/mock';
import { BookOpen, Download } from 'lucide-react';

const CoursesSection = () => {
  return (
    <section id="courses" className="py-24 md:py-32 bg-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            {coursesData.title}
          </h2>
          <div className="w-24 h-1.5 bg-[#DA8347] mx-auto rounded-full" />
        </div>

        {/* Courses Grid - Card Style */}
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-5">
          {coursesData.courses.map((course, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 flex items-center gap-4 shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#DA8347] to-[#c46f35] rounded-xl flex items-center justify-center shadow-sm">
                <BookOpen className="w-6 h-6 text-white" />
              </div>
              <span className="text-gray-800 font-medium text-lg leading-tight">{course}</span>
            </div>
          ))}
        </div>

        {/* PDF Download Button */}
        <div className="mt-14 text-center">
          <a
            href={coursesData.pdfLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#DA8347] text-white px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 hover:bg-[#c46f35] hover:shadow-xl hover:-translate-y-1 shadow-lg"
          >
            <Download size={24} />
            {coursesData.pdfButtonText}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
